import React, { } from "react";
import { Button } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { documentLabelPanelAction } from "../../../context/actions/documentLabelPanelAction";
import "../index.scss";
import TermContactPrivacyNotice from "../TermContactPrivacyNotice"
import {clientEmail} from "../../../utils/constants";

const PrivacyNotice = () => {

    const documentLabelPanelOnState = useSelector(state => state.documentLabelPanelReducer.documentLabelPanelOn);
    const dispatch = useDispatch();

    const documentLabelPanelHandler = () => {
        dispatch(documentLabelPanelAction(!documentLabelPanelOnState))
    }
    const overlayHandler = () => {
        dispatch(documentLabelPanelAction(false))
    }
    return (



        <div className="privacy-notice-page">
            <section className="content-section">
                <div className="content-section-md">
                    <p>
                        At TRAiNED, we understand that your privacy is an important part of the trust you place in us. This Notice explains how we collect, use, disclose and otherwise process personal information in connection with our services. Please see section below for further details.
                    </p>
                </div>
                <div className="content-section-md">
                    <h2>Learn More About Privacy Rights</h2>
                    <ul>
                        <li>
                            <a href="#section1">What is Personal Information?</a>
                        </li>
                        <li>
                            <a href="#section2">Our Collection of Personal Information</a>
                        </li>
                        <li>
                            <a href="#section3">Our Use of Personal Information</a>
                        </li>
                        <li>
                            <a href="#section4">Cookies, Related Technologies & Online Ads</a>
                        </li>
                        <li>
                            <a href="#section5">
                                Our Disclosure of Personal Information
                            </a>
                        </li>
                        <li>
                            <a href="#section6">Communication Preferences</a>
                        </li>
                        <li>
                            <a href="#section7">Region-Specific Disclosures</a>
                        </li>
                        <li>
                            <a href="#section8">Children’s Privacy</a>
                        </li>
                        <li>
                            <a href="#section9">Third Party Websites</a>
                        </li>
                        <li>
                            <a href="#section10">Changes to This Notice</a>
                        </li>
                        <li>
                            <a href="#contactUs">
                                How to Contact Us
                            </a>
                        </li>
                    </ul>
                </div>
                <div className="content-section-md">
                    <h2>Additional Notices</h2>
                    <div className="content-section-inner">
                        <h4>California Privacy Disclosures</h4>
                        <p>
                            These Additional California Privacy Disclosures supplement the information contained in this TRAINED Privacy Notice. These Disclosures apply solely to our processing of personal information of individual residents of the State of California within the scope of the California Consumer Privacy Act of 2018 (CCPA).
                        </p>
                    </div>
                    <div className="content-section-inner">
                        <h4>TRAINED Cookie Notice </h4>
                        <p>
                            The Cookie Notice supplements the information contained in this Privacy Notice, explaining how we and our business partners and services providers use cookies and related technologies in the course of managing and providing our online services and our communications to you. It explains what these technologies are and why we use them, as well as your rights to control our use of them.
                        </p>
                    </div>
                    <div className="content-section-inner bg-style-1">
                        <h4>Who We Are</h4>
                        <p>
                            TRAINED: TRAINED is an integrated technology solutions provider primarily serving business and governmental entities. TRAINED is headquartered in the United States. When we use the terms “TRAINED”, “we”, “us”, or “our” in this Notice, we are referring to TRAINED and its subsidiaries and affiliated companies worldwide.
                        </p>
                    </div>
                </div>
                <div className="content-section-md">
                    <h2>Services Covered By This Notice</h2>
                    <p>
                        <strong>Our Services:</strong> When we use the term “services”, we are referring to all the services that we offer on our own behalf, including our product offerings and the websites and mobile applications that post or link to this Notice.  We are not referring to services that we provide solely on behalf of a third party, such as outsourced IT services we may provide to another company. Please refer to the privacy notice of the third party with which you have a relationship for information on how they engage service providers, like us, to process personal information on their behalf.
                    </p>
                </div>
            </section>
            <section className="content-section" id="section1">
                <h2>What is Personal Information?</h2>
                <p>
                    When we use the term “personal information” in this Notice, we mean information that identifies, relates to, describes, is reasonably capable of being associated with, or could reasonably be linked, directly or indirectly, to you. It does not include aggregated or deidentified information that is maintained in a form that is not capable of being associated with or reasonably linked to you.
                </p>
            </section>

            <section className="content-section" id="section2">
                <h2>Our Collection of Personal Information</h2>
                <p>
                    From the first moment you interact with us, we are collecting personal information about you. Sometimes we collect personal information automatically when you interact with our services and sometimes we collect the personal information directly from you. At times, we may collect personal information about you from other sources and third parties, even before our first direct interaction.
                </p>
            </section>

            <section className="content-section" id="section3">
                <h2>Personal Information You Provide</h2>
                <div className="content-section-md">
                    <h2>Contact Information</h2>
                    <p>Such as your name, email address, business mailing address and phone number </p>
                </div>
                <div className="content-section-md">
                    <h2>Employment Information</h2>
                    <p>Such as your job title, department, employer or business,</p>
                </div>
                <div className="content-section-md">
                    <h2>Account Information</h2>
                    <p>Such as your account ID, customer ID, username and password </p>
                </div>
                <div className="content-section-md">
                    <h2>Transaction Information</h2>
                    <p>Such as payment information, credit information, purchase details, and order preferences</p>
                </div>
                <div className="content-section-md">
                    <h2>Event Information</h2>
                    <p>Such as your attendance at a TRAINED event </p>
                </div>
                <div className="content-section-md">
                    <h2>Survey Information</h2>
                    <p>Such as your responses to survey questions about your business and your satisfaction with TRAINED </p>
                </div>
                <div className="content-section-md">
                    <h2>Contest Entry Information</h2>
                    <p>Such as your statements and submissions for entry in a contest</p>
                </div>
                <div className="content-section-md">
                    <h2>User Generated Content</h2>
                    <p>To the extent it is personal information, such as product or service reviews connected to you</p>
                </div>
                <div className="content-section-md">
                    <h2>Inquiry Information</h2>
                    <p>Such as the content of your email, text, or chat with us and, where applicable, your voice from calls with us</p>
                </div>
            </section>

            <section className="content-section">
                <h2>Personal Information Automatically Collected</h2>
                <div className="content-section-md">
                    <h2>Log File Data</h2>
                    <p>Including your IP address, device operating system, application software, browser type, peripheral devices, language, user log and clickstream data, access times, and any relative Active Directory information</p>
                </div>
                <div className="content-section-md">
                    <h2>Cookies and Related Technology Data</h2>
                    <p>Including your usage and activity on our online services, such as information relating to your activity, using essential and non-essential cookies, web beacons and related data collection technologies</p>
                </div>
                <div className="content-section-md">
                    <h2>Location Data</h2>
                    <p>Including your general geographic location based on your IP address</p>
                </div>

            </section>

            <section className="content-section">
                <h2>Personal Information from Other Sources and Third Parties</h2>
                <div className="content-section-md">
                    <h2>Personal Information from Our Business Partners and Service Providers</h2>
                    <p>Our business partners, such as product and software providers, collect personal information and often share some or all of this information with us. For example, we receive contact information from our product providers when we engage in co-marketing campaigns for purposes of contacting prospective customers or investors who may be interested in their products.</p>
                </div>
                <div className="content-section-md">
                    <h2>We Collect Personal Information from Our Service Providers</h2>
                    <p>Our service providers, such as payment processors and analytics providers, collect personal information and often share some or all of this information with us. For example, we receive Personal Information from vendors to coordinate events, facilitate survey activities, identify prospective customers or investors and conduct marketing and analytics.</p>
                </div>
                <div className="content-section-md">
                    <h2>We Collect Personal Information from Information Providers</h2>
                    <p>We may purchase, lease or otherwise obtain lists or information from third-party list or information providers to correct or supplement contact information we collect. For example, we may obtain updated contact information from third-party information providers to reconnect with prospective clients.</p>
                </div>
                <div className="content-section-md">
                    <h2>We Collect Personal Information from Publicly Available Sources</h2>
                    <p>We often collect personal information that we do not otherwise have (including contact information, employment information and product preferences) from websites and other publicly available sources for our business operations, including identifying prospective customers or correcting outdated contact information.</p>
                </div>
            </section>

            <section className="content-section" id="section3">
                <h2>Our Use of Personal Information</h2>
                <p>
                    We use your personal information to administer your account with us, provide and improve our and our business partners’ services and products, provide you with information based on your interactions with us, contact you about our services and products, coordinate with our business partners to allow them to participate in limited co-marketing opportunities with us, respond to your inquiries and requests, prevent and investigate fraud, protect legal and contractual rights and comply with legal obligations.
                </p>
                <div className="content-section-md">
                    <p>
                        <strong>We use personal information we collect to:</strong>
                    </p>
                    <ul>
                        <li>
                            Create and administer your account with us;
                        </li>
                        <li>
                            Process your order and credit requests;
                        </li>
                        <li>
                            Deliver products and services you request;
                        </li>
                        <li>
                            Send you transaction information, including confirmations, invoices, technical notices, product and services information, updates, security alerts, support and administrative messages, and information about your credit with us;
                        </li>
                        <li>
                            Communicate with you about and facilitate new promotions and upcoming events;
                        </li>
                        <li>
                            Provide you with news about products and services offered by us and our business partners;
                        </li>
                        <li>
                            Coordinate with our business partners to allow them to participate in limited co-marketing opportunities with us;
                        </li>
                        <li>
                            Respond to your comments and questions and provide customer service;
                        </li>
                        <li>
                            Link or combine with other information we get from third parties, to help understand your needs, customize our offerings to those needs, and provide you with better service;
                        </li>
                        <li>
                            Conduct research and surveys used to measure our performance and improve our and our business partners’ products, services and customer experience;
                        </li>
                        <li>
                            Operate and improve our and our business partners’ services and products;
                        </li>
                        <li>
                            Facilitate the provision of software updates, product support, and other services related to our and our business partners’ mobile applications and other products;
                        </li>
                        <li>
                            Manage investor relations and investments in our company, including by providing you information about our company and related investments, processing investment transactions and paying dividends, preparing tax returns and other investor-related documents, and managing our cap table;
                        </li>
                        <li>
                            Prevent, investigate or provide notice of fraud or unlawful or criminal activity;
                        </li>
                        <li>
                            Enforce and carry out contracts and agreements;
                        </li>
                        <li>
                            And Comply with legal obligations.
                        </li>
                    </ul>
                </div>
            </section>

            <section className="content-section" id="section4">
                <h2>Cookies, Related Technologies & Online Ads</h2>
                <p>
                    As described in the <a href="#">Our Collection of Personal Information</a>  section of this Notice, we and our third-party partners and providers automatically collect certain types of information about your online activities over time and across websites, including our online services and other websites you may visit. We collect this information through our or our third-party partners' and providers’ use of a variety of technologies, including cookies, web beacons, pixels, embedded scripts, location-identifying technologies, and logging technologies. Many of these technologies are used to run our online services, assess the performance of our online services, allow you to use certain non-essential features of our online services or conduct analytics on the traffic and usage trends of our online services, including statistics about our customer base. However, some of these technologies are used to make advertisements and marketing materials more relevant to you and your interests, including through the use of advertising tracking technologies. You have certain choices that may limit or affect our and our third-party partners' and providers’ ability to use cookies and related technologies for these purposes.
                </p>
                <p>
                    You can view the TRAINED Cookie Notice <a href="#">here</a>.
                </p>
            </section>

            <section className="content-section" id="section5">
                <h2>Our Disclosure of Personal Information</h2>
                <p>
                    We disclose personal information in the following ways:
                </p>
                <p>
                    <img className="img-fluid" src={require('../../../assets/img/graph.png')} alt="Graph" />
                </p>
                <div className="content-section-md">
                    <h2>We Disclose Personal Information Within TRAINED</h2>
                    <p>We are able to offer you the products and services we make available because of the hard work of our team members. For example, we may disclose your contact information and transaction information to process an order or to facilitate communication between you and a TRAINED representative.</p>
                </div>
                <div className="content-section-md">
                    <h2>We Disclose Personal Information to Our Business Partners</h2>
                    <p>We coordinate with a number of third parties with whom we do business to make our and their products and services available to you. We disclose personal information to these business partners for such purposes as facilitating a better user experience of the TRAiNED products and offerings. </p>
                </div>
                <div className="content-section-md">
                    <h2>We Disclose Personal Information to Our Service Providers</h2>
                    <p>We engage a number of service providers to perform functions and services on our behalf and under our instruction to make our products and services available to you. For example, we may disclose transaction information to our payment processors and/or invoicing partners to facilitate your transaction and we may disclose additional personal information to service providers for auditing, compliance, investment management and corporate governance functions. </p>
                </div>
                <div className="content-section-md">
                    <h2>We Disclose Personal Information to Our Suppliers and Distributors</h2>
                    <p>We coordinate with and disclose personal information to a team of suppliers and distributors for purposes of developing and executing proposed and completed transactions facilitated by us, as well as improving our performance, products and services. Our suppliers and distributors also use personal information for their own internal purposes (including administrative purposes).</p>
                </div>
                <div className="content-section-md">
                    <h2>We Disclose Personal Information to Our Advertising Partners</h2>
                    <p>We coordinate with and disclose personal information to advertising partners, such as search engines and social media advertising providers, for purposes of serving personalized and targeted advertisements to you on third-party platforms. For more information, including how to opt out of interest-based advertising, please refer to our <a href="">Cookies, Related Technologies & Online Ads</a> section.</p>
                </div>
                <div className="content-section-md">
                    <h2>We Disclose Personal Information with Your Consent</h2>
                    <p>We may disclose personal information about you to certain other third parties not described in this Notice with your consent.</p>
                </div>
                <div className="content-section-md">
                    <h2>We Disclose Personal Information for Corporate Business Transactions</h2>
                    <p>We may take part in or be involved with a corporate business transaction, such as a merger, acquisition, joint venture, or financing or sale of company assets. We may disclose personal information to a third party during negotiation of, in connection with or as an asset in such a corporate business transaction. Personal information may also be disclosed in the event of insolvency, bankruptcy or receivership.</p>
                </div>
                <div className="content-section-md">
                    <h2>We Disclose Personal Information in Accordance with Our Legal Obligations and Rights</h2>
                    <p>We may disclose personal information to third parties, such as legal advisors and law enforcement:</p>

                    <ul>
                        <li>
                            in connection with the establishment, exercise, or defense of legal claims;
                        </li>
                        <li>
                            to comply with laws or to respond to lawful requests and legal process;
                        </li>
                        <li>
                            to protect the rights and property of us, our agents, customers, and others, including to enforce our agreements, policies, and terms of use;
                        </li>
                        <li>
                            to detect, suppress, or prevent fraud;
                        </li>
                        <li>
                            to reduce credit risk and collect debts owed to us;
                        </li>
                        <li>
                            to protect the health and safety of us, our customers, or any person; or
                        </li>
                        <li>
                            as otherwise required by applicable law.
                        </li>
                    </ul>
                </div>
            </section>

            <section className="content-section" id="section6">
                <h2>Communication Preferences</h2>
                <p>
                    If you have opted in to our marketing communications (or where permitted by law, if you have provided us or we have obtained your contact information), we may send you email messages, direct mail offers, push notifications or other communications regarding products or services depending on the method of communication selected. You may ask us not to do so by:
                </p>
                <ul>
                    <li>
                        following the opt-out instructions in promotional communications;
                    </li>
                </ul>
            </section>
            <section className="content-section" id="section7">
                <h2>Region-Specific Disclosures</h2>
                <p>
                    We may choose or be required by law to provide different or additional disclosures relating to the processing of personal information about residents of certain countries and regions. Please click below to review additional disclosures applicable to you:
                </p>
                <ul>
                    <li>
                        If you are a resident of the State of California in the United States, click <a href="">here</a> for additional California privacy disclosures.
                    </li>
                    <li>
                        If you are a resident of the State of Nevada in the United States, Chapter 603A of the Nevada Revised Statutes permits a Nevada resident to opt out of future sales of certain covered information that a website operator has collected or will collect about the resident. To submit such a request, please contact us at
                        <a href={`mailto:${clientEmail}`}> {clientEmail}</a>.
                    </li>
                </ul>
            </section>
            <section className="content-section" id="section8">
                <h2>Children’s Privacy</h2>
                <p>
                    Our online services are general audience sites intended for corporate and governmental users. Our services are not directed to, and we do not intend to, or knowingly, collect or solicit personal information from children under the age of 13. If you are under the age of 13, do not use our services or provide us with any personal information either directly or by other means. If a child under 13 has provided personal information to us, we encourage the child’s parent or guardian to contact us to request that we remove the personal information from our systems. If we learn that any personal information we collect has been provided by a child under the age of 13, we will promptly delete that personal information.
                </p>
            </section>
            <section className="content-section" id="section9">
                <h2>Third Party Websites</h2>
                <p>
                    Except where we post, link to or expressly adopt or refer to this Notice, this Notice does not apply to, and we are not responsible for, any personal information practices of third-party websites and online services or the practices of other third parties. To learn about the personal information practices of third parties, please visit their respective privacy notices.
                </p>
            </section>
            <section className="content-section" id="section10">
                <h2>Changes to This Notice</h2>
                <p>
                    We may update this Notice from time to time. When we make changes to this Notice, we will change the date at the end of this Notice to include the "Last Updated" date. If we make material changes to this Notice, we will notify you by email to your registered email address, by prominent posting on our services, or through other appropriate communication channels. All changes shall be effective from the date of publication unless otherwise provided in the notification.
                </p>
            </section>
            <TermContactPrivacyNotice id="contactUs" />
        </div>





    )
};
export default PrivacyNotice;

